import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import InputDate from 'components/Inputs/inputDate';
import { Calendar, ChevronDown } from 'lucide-react';
import { Skeleton } from '@mui/material';
import { useRect } from 'utils/customHooks';
import Portal from 'components/Portal';

function DateSelector({
  date = null,
  literals,
  literalsCommon,
  captable,
  onChange = () => { },
}) {
  const POPUP_TIMELINE = 'timeline';

  const [popup, setPopup] = useState(null);
  const [bbox, ref, visible] = useRect(popup);
  const [operation, setOperation] = useState(captable?.operations?.[0] || false);

  const handleChange = (newOperation) => {
    setOperation(newOperation);
    setPopup(null);
    if (typeof onChange === 'function') {
      onChange(newOperation.date);
    }
  };

  useEffect(() => {
    if (date && date !== operation.date) {
      setOperation(captable.operations.find(op => op.date === date) || { date });
    } else if (!date && captable?.operations?.length) {
      onChange(captable.operations[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    onChange(captable?.operations?.[0]?.date || null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captable.selected]);

  const name = operation.name?.length > 15 ? `${operation.name.slice(0, 15)}...` : operation.name;
  const renderText = operation
    ? `${name ? `${name} - ` : ''} ${operation.date}`
    : '';

  const styles = { visible };
  if (bbox) {
    styles.top = bbox.bottom + 5;
    styles.left = bbox.left;
  }

  return (
    <>
      <div ref={ref} className='captable-selector timeline' onClick={() => setPopup(POPUP_TIMELINE)}>
        <span className='captable-selector--left'>
          <Calendar size={16} />
          {captable.loaded
            ? <span className='captable-selector--name'>{renderText}</span>
            : <Skeleton width='80px' />}
        </span>
        <ChevronDown size={16} />
      </div>
      {
        popup === POPUP_TIMELINE && (
          <Portal styles={styles} onClose={() => setPopup(null)}>
            <div className='captable-popup timeline'>
              <InputDate
                preText={literalsCommon.date}
                value={date}
                onChange={handleChange}
              />

              <h6>{literals.timeline}</h6>
              <div className='captable-popup-items simple-scrollbar'>
                {captable.operations.map(auxOperation => (
                  <div
                    key={auxOperation.id}
                    className={`captable-popup-item ${auxOperation.id === operation.id ? 'selected' : ''}`}
                    onClick={() => handleChange(auxOperation)}
                  >
                    <div className={`captable-popup-item--left ${auxOperation.date === operation.date ? 'selected' : ''}`}>
                      <div className='captable-popup-item--icon'><Calendar size={16} /></div>
                      <div className='d-flex flex-column justify-content-center'>
                        <h6 className='captable-popup-item--name' title={auxOperation.name}>{auxOperation.name}</h6>
                        <p className='captable-popup-item--date'>{auxOperation.date}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Portal>
        )
      }
    </>
  );
}

DateSelector.propTypes = {
  literals: PropTypes.object.isRequired,
  literalsCommon: PropTypes.object.isRequired,
  date: PropTypes.string,
  captable: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

export default DateSelector;
